export default __webpack_public_path__ + "static/media/logo.25a1a75f.jpg";